import { createDiv, createDropdown, createPara, createSVG, createTextArea, createTextField } from "../utils/utils.js";
import { db } from "../firebase.js";
import { collection, addDoc,serverTimestamp } from "firebase/firestore";
import { auth } from "../firebase.js"; 
import {fetchUserTasks,countingUserTasks,settingHeaderCountText} from "./mainContent.js" 

export default function creatingNewTask(){

  const root = document.querySelector(".container");
  const getNewTaskMain = createDiv(root,"new-task-main");

  // Creating new task header
  const getNewTaskHeader = createDiv(getNewTaskMain,"new-task-header");
  createPara(getNewTaskHeader,"new-task-header-title","Task:");
  const getCloseNewTask = createSVG(getNewTaskHeader,"new-task-close-svg","M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z");

  getCloseNewTask.addEventListener("click",()=>{
      getNewTaskMain.classList.remove("quick-show"); // Hides the creates new task div on clicking close.
      getMain.classList.remove("adjust-main-right") // Removes margin from right on the main content.

  })

  const getTaskTitle = createTextField(getNewTaskMain,"new-task-title","Task Title"); // Text field for new task title
  const getTaskDetail = createTextArea(getNewTaskMain,"new-task-descirption","Description"); // Text field for new task description

  // New task priority div
  const getNewTaskPriority = createDiv(getNewTaskMain,"new-task-priority");
  const getTaskPriority = createDropdown(getNewTaskPriority,"priority","Choose Priority ","priority",[{value: "high", label: "High"},{ value: "medium", label: "Medium" },{ value: "low", label: "Low" }]);

  // New task due date div
  const today = new Date().toISOString().split("T")[0];
  const getNewTaskDueDate = createDiv(getNewTaskMain,"new-task-due-date");
  const getDueDatePara = createPara(getNewTaskDueDate,"due-date-title","Due date");
  const getTaskDueDate = createTextField(getNewTaskDueDate,"date-time-input","Date & Time","date");
  getTaskDueDate.value = today;
  getTaskDueDate.min = new Date().toISOString().split("T")[0];

  // Save changes button div
  const getSaveTaskMain = createDiv(getNewTaskMain,"save-task-div-main");
  const getSaveTask = createDiv(getSaveTaskMain,"save-task-div");
  createPara(getSaveTask,"save-task-text","Save Task")

  const darkModeButton = document.querySelector(".sidebar-setting");
  const getAllLabels = document.querySelectorAll(".new-task-main label");
  const getPrioritySelect = document.querySelector(".new-task-main select");
  const main = document.querySelector(".main");

  darkModeButton.addEventListener("click",()=>{
    getNewTaskMain.classList.toggle("sidebar-dark-mode");
    getNewTaskMain.classList.toggle("dark-mode-font-bright");
    getTaskTitle.classList.toggle("dark-mode-texfield-color");
    getTaskDetail.classList.toggle("dark-mode-texfield-color");
    getPrioritySelect.classList.toggle("dark-mode-texfield-color");
    getTaskDueDate.classList.toggle("dark-mode-texfield-color");
    getAllLabels.forEach(label => {
      label.classList.toggle("dark-mode-font-bright")
    });
    getDueDatePara.classList.toggle("dark-mode-font-bright");
    getCloseNewTask.classList.toggle("dark-mode-svg-fill");
  });

  const user = auth.currentUser;
  const getSidebarHighTaskList = document.querySelector(".sidebar-high-tasks");
  const getSidebarNormalTaskList = document.querySelector(".sidebar-normal-tasks");
  const getSidebarLowTaskList = document.querySelector(".sidebar-low-tasks");
  const getSidebarTodayTask = document.querySelector(".sidebar-today-tasks");
  const getSidebarPastTask = document.querySelector(".sidebar-past-tasks");
  const getSidebarUpcomingTask = document.querySelector(".sidebar-upcoming-tasks");
  let task;

  // On clicking the save button, adding the task details in the firestore
  getSaveTask.addEventListener("click", async () => {
      if (user) {
        try {
          await addTask(user.uid, getTaskTitle.value, getTaskDetail.value, getTaskPriority.value, getTaskDueDate.value);
        } catch (err) {
          console.error("Error adding task:", err);
        }
      }
    // Findling out when user saved the task, he was on which category i.e. Today task, upcoming etc then passing that to fetchUserTask() function.
      if (getSidebarHighTaskList.classList.contains("selected-task") || getSidebarHighTaskList.classList.contains("selected-task2"))
     {
        task = "high";
      }
      else if (getSidebarNormalTaskList.classList.contains("selected-task") || getSidebarNormalTaskList.classList.contains("selected-task2")) {
        task = "medium";
      }
      else if  (getSidebarLowTaskList.classList.contains("selected-task") || getSidebarLowTaskList.classList.contains("selected-task2")) {
        task = "low";
      }
      else if (getSidebarTodayTask.classList.contains("selected-task") || getSidebarTodayTask.classList.contains("selected-task2")) {
        task = "today";
      }
      else if (getSidebarPastTask.classList.contains("selected-task") || getSidebarPastTask.classList.contains("selected-task2")) {
        task = "past";
      }
      else if (getSidebarUpcomingTask.classList.contains("selected-task") || getSidebarUpcomingTask.classList.contains("selected-task2")) {
        task = "upcoming";
      }  
      fetchUserTasks(task);
    // --------------------------------

      countingUserTasks();
      getNewTaskMain.classList.remove("quick-show");
      getMain.classList.remove("adjust-main-right")
  });
     
       // Fetching the create new task button and main container from mainContent.js
      const getMain = document.querySelector(".main");
      const getNewTaskButton = document.querySelector(".create-new-task"); 

      getNewTaskButton.addEventListener("click",()=>{

        // Clearing out the old values
        getTaskTitle.value = "";
        getTaskDetail.value = "";
        getTaskPriority.value = "high";
        getTaskDueDate.value = today;

        getNewTaskMain.classList.add("quick-show");
          if (window.innerWidth > 500) {
              getMain.classList.add("adjust-main-right") // Adds margin from right on the main content.
          }
      })
}

// Function for saving the task details.
async function addTask(userId, title, description, priority, dueDate) {
    try { await addDoc(collection(db, "Tasks"), {
        userId,
        title,
        description,
        priority,
        dueDate, 
        createdAt: serverTimestamp()
      });
    } catch (error) {
        console.error("Error adding task:", error);
    }
}
